/* eslint-disable max-len */
// i18next-extract-mark-ns-start LaRubrique
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useTranslation } from 'gatsby-plugin-react-i18next';
import {
  colors, tabletThresholdPixels, Title1 as StyledTitle1, Button,
} from '../home/v3/styledComponents';
import withAppContext from '../../withAppContext';
import CTALink from '../CTALink';

const Title = styled(StyledTitle1)`
  margin: 0px;
  text-align: start;
  color: ${colors.white};
  font-size: 60px;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 40px;
  }
`;

const Subtitle = styled.h2`
  font-family: 'Space Mono', monospace;
  font-weight: normal;
  color: ${colors.white};
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  max-width: 730px;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 14px;
  }
`;

const Image = styled.img`
  width: 100%;
  max-height: 100%;
  overflow: hidden;
  object-fit: cover;
  `;

const HeaderBanner = styled.div`
  position: relative;
  background-color: ${colors.beigeGrey};
  height:595px;
  display: flex;
  justify-content: center;
  @media (max-width: ${tabletThresholdPixels}) {
    height: 400px;
  }
  `;
const HeaderBannerContent = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 24px;
  top: 50%;
  width: 100%;
  max-width: 1200px;
  transform: translateY(-50%);
  align-items: baseline;
  box-sizing: border-box;
  @media (max-width: ${tabletThresholdPixels}) {
    padding: 0 20px;
  }
  `;
const StyledButton = styled(Button)`
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 50%);
  width: calc(100vw - 27px);
`;

function LaRubriqueHeader({ context: { isMobile } }) {
  const { t } = useTranslation();
  return (
    <HeaderBanner>
      <Image
        src="https://res.cloudinary.com/dlyzl32tm/image/upload/v1709625067/heroBannerBlog_asnspf.png"
        alt={t('La rubrique banner')}
      />
      <HeaderBannerContent>
        <Title>{t('Le carnet Tilli')}</Title>
        <Subtitle>
          {t(
            'Upcycling, conseils couture, astuces réparation et personnalisation ... : retrouvez ici l’ensemble de nos articles pour réinventer votre dressing et donner une seconde vie à vos vêtements, accessoires et linge de maison.',
          )}
        </Subtitle>
        {!isMobile && (
          <CTALink fromInteraction="LaRubrique_Header">
            <Button>{t('Réaliser un devis')}</Button>
          </CTALink>
        )}
      </HeaderBannerContent>
      {isMobile && (
        <CTALink fromInteraction="LaRubrique_Header">
          <StyledButton black>{t('Réaliser un devis')}</StyledButton>
        </CTALink>
      )}
    </HeaderBanner>
  );
}
LaRubriqueHeader.propTypes = {
  context: PropTypes.shape({
    isMobile: PropTypes.bool,
  }).isRequired,
};

export default withAppContext(LaRubriqueHeader);
